import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

export const useCompanyAuthStore = create(
  devtools(
    persist(
      (set, get) => ({
        // Company Auth state
        companyId: null,
        companyName: null,
        token: null,
        role: null,
        maxusers: null,
        acctype: null,
        subscription_type: null,
        plantype: null,
        isCompanyAdmin: false,

        // Actions
        setCompanyAuthData: (authData) =>
          set(
            {
              companyId: authData.companyId,
              companyName: authData.companyName,
              token: authData.token,
              role: authData.role,
              maxusers: authData.maxusers,
              acctype: authData.acctype,
              subscription_type: authData.subscription_type,
              plantype: authData.plantype,
              isCompanyAdmin: true,
            },
            false,
            "set-company-auth-data"
          ),

        setToken: (token) => set({ token }, false, "set-company-token"),

        clearCompanyAuthData: () =>
          set(
            {
              companyId: null,
              companyName: null,
              token: null,
              role: null,
              maxusers: null,
              acctype: null,
              subscription_type: null,
              plantype: null,
              isCompanyAdmin: false,
            },
            false,
            "clear-company-auth-data"
          ),

        // Utility getters
        getToken: () => get().token,
        getCompanyId: () => get().companyId,
        getCompanyName: () => get().companyName,
        getRole: () => get().role,
        isCompanyAdminAuthenticated: () => get().isCompanyAdmin && !!get().token,
      }),
      {
        name: "company-auth-storage",
        partialize: (state) => ({
          companyId: state.companyId,
          companyName: state.companyName,
          token: state.token,
          role: state.role,
          maxusers: state.maxusers,
          acctype: state.acctype,
          subscription_type: state.subscription_type,
          plantype: state.plantype,
          isCompanyAdmin: state.isCompanyAdmin,
        }),
      }
    ),
    {
      name: "company-auth-store",
    }
  )
);

